import toggleOverlay from '../utils/toggleOverlay';
import { BREAKPOINTS, HEADER } from '../utils/constants';

const initHeader = (): void => {
  const headerEl = document.querySelector<HTMLElement>('[data-header]');
  if (!headerEl) return;
  const desktopMediaQuery: MediaQueryList = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`);
  const navToggleEl = headerEl.querySelector<HTMLButtonElement>('[data-navigation-toggle]');
  const navigationEl = headerEl.querySelector<HTMLDialogElement>('[data-navigation]');
  if (!navigationEl || !navToggleEl) return;
  const navigationSubmenuEls = navigationEl.querySelectorAll<HTMLUListElement>(HEADER.SUBMENU_SELECTOR);

  enum NAV_SUBMENU_STATE {
    ACTIVE = 'active',
    HIDDEN = 'hidden',
  }

  const resetNavSubmenus = (): void => {
    navigationSubmenuEls.forEach((submenu): void => {
      submenu.dataset.navState = NAV_SUBMENU_STATE.HIDDEN;
      submenu.classList.add(HEADER.HIDDEN_CLASS);
      submenu.scroll(0, 0);
    });
    navigationEl.scroll(0, 0);
  };

  const resetNavigation = (): void => {
    resetNavSubmenus();
    toggleOverlay(false);
    navToggleEl.classList.remove('nav-open');
    navigationEl.classList.add(HEADER.HIDDEN_CLASS);
    navToggleEl.setAttribute('aria-expanded', String(false));
  };

  const toggleNavigation = (): void => {
    const isOpen = navToggleEl.classList.toggle('nav-open');
    const overlayEl = toggleOverlay(isOpen);
    navToggleEl.setAttribute('aria-expanded', String(isOpen));
    navigationEl.classList.toggle(HEADER.HIDDEN_CLASS, !isOpen);
    if (isOpen) {
      overlayEl?.addEventListener('click', toggleNavigation);
      resetNavSubmenus();
    } else {
      overlayEl?.removeEventListener('click', toggleNavigation);
    }
  };

  const openNavSubmenu = (link: HTMLAnchorElement, evt: Event): void => {
    if (!desktopMediaQuery.matches) {
      evt.preventDefault();
      const nextSubmenuEl = link.nextElementSibling as HTMLUListElement | null;
      const activeSubmenuEl = link.closest<HTMLUListElement>(HEADER.SUBMENU_SELECTOR);
      if (activeSubmenuEl) activeSubmenuEl.dataset.navState = NAV_SUBMENU_STATE.HIDDEN;
      if (nextSubmenuEl) {
        nextSubmenuEl.dataset.navState = NAV_SUBMENU_STATE.ACTIVE;
        nextSubmenuEl.classList.remove(HEADER.HIDDEN_CLASS);
      }
    }
  };

  const closeNavSubmenu = (btn: HTMLButtonElement): void => {
    const activeSubmenuEl = btn.closest<HTMLUListElement>(HEADER.SUBMENU_SELECTOR);
    if (activeSubmenuEl) {
      activeSubmenuEl.classList.add(HEADER.HIDDEN_CLASS);
      activeSubmenuEl.dataset.navState = NAV_SUBMENU_STATE.HIDDEN;
    }
  };

  navToggleEl.addEventListener('click', toggleNavigation);
  navigationEl.addEventListener('click', (evt: Event): void => {
    const target = evt.target as HTMLElement | null;
    const navigationParentLink = target?.closest<HTMLAnchorElement>('[data-navigation-parent]');
    if (navigationParentLink) {
      openNavSubmenu(navigationParentLink, evt);
      return;
    }
    const navigationBackBtn = target?.closest<HTMLButtonElement>('[data-navigation-back]');
    if (navigationBackBtn) {
      closeNavSubmenu(navigationBackBtn);
      return;
    }
  });
  desktopMediaQuery.addEventListener('change', resetNavigation);
};

export default initHeader;
